var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('b-tooltip',{attrs:{"multilined":"","type":"is-dark","label":_vm.tooltip}},[_c('b-icon',{staticClass:"has-cursor-help",attrs:{"icon":"info-circle","size":"is-small"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }